import React from "react";
import { Tag, Space, Button, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import DataTable from "../../../components/DataTable";

const roleColors = {
  admin: "#49627a",
  public: "#2b751d",
  alpha: "#e29b45",
  gamma: "#bd565d",
  "sql lab": "#6c757d",
};

const getRoleColor = (roleName) =>
  roleColors[roleName.toLowerCase()] || "default";

export default function SkeyechartUsersTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  onEditUser,
  onDeleteUser,
  isRoleUser,
}) {
  const columns = [
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      width: "15%",
      sorter: (a, b) => (a.username || "").localeCompare(b.username || ""),
    },
    {
      title: "Name",
      key: "name",
      width: "15%",
      render: (_, record) =>
        `${record.first_name || ""} ${record.last_name || ""}`.trim() ||
        record.username,
      sorter: (a, b) => (a.first_name || "").localeCompare(b.first_name || ""),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "20%",
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
    },
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      width: "10%",
      render: (active) => (
        <Tag color={active ? "success" : "error"}>
          {active ? "Active" : "Inactive"}
        </Tag>
      ),
      sorter: (a, b) => (a.active === b.active ? 0 : a.active ? -1 : 1),
    },
    {
      title: "Roles",
      dataIndex: "roles",
      key: "roles",
      width: "30%",
      render: (roles) => (
        <Space size={[0, 4]} wrap>
          {(roles || []).map((role, idx) => (
            <Tag color={getRoleColor(role)} key={idx}>
              {role}
            </Tag>
          ))}
        </Space>
      ),
    },
  ];

  if (!isRoleUser) {
    columns.push({
      title: "Actions",
      key: "actions",
      width: "10%",
      render: (_, record) => (
        <Space size="small">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEditUser(record)}
            style={{ color: "#e29b45" }}
            title="Edit User"
          />
          <Popconfirm
            title="Delete User"
            description={`Are you sure you want to delete "${record.username}"?`}
            onConfirm={() => onDeleteUser(record.id)}
            okText="Yes"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              title="Delete User"
            />
          </Popconfirm>
        </Space>
      ),
    });
  }

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
